import React from "react";
import CustemButton from "./CustomButton";
import ThemeColor from "../../theme/ThemeColor";


const ButtonsGroup =({text, onClick, isActive, sx}) =>{

 return(
    <>
        <CustemButton variant="contained" onClick={onClick} id ='next' text={text} backgroundColor= {isActive ? ThemeColor.palette.ButtonColor : ThemeColor.palette.LightGrayColor} sx={{...sx, color:isActive ? '#FFFFFF':'#000000' , fontFamily:'Inter', fontSize:'20px', letterSpacing:'0.5px', pl:3, pr:3, pt:0.5, pb:0.5, fontWeight:400}}/>
    </>
    )
}

export default ButtonsGroup

